import React from 'react';
import {ReactComponent as CutleryIco} from "../../../../../images/icons/cutlery.svg";
import {useNavigate} from "react-router-dom";
import AppConfig from "../../../../services/AppConfig";
import {usePrefix} from "../../../../services/Prefix";

interface Props {
    name: string;
    id: number;
    active: boolean;
}

const MenuTab = ({name, id, active}: Props) => {
    const navigate = useNavigate();
    const prefix = usePrefix();

    const handleClick = () => {
        navigate(AppConfig.getLinkWithPrefix("/menu/" + id, prefix));
    }

    return (
        <button className={`btn btn-default btn-lg text-nowrap ${active ? "active" : ""}`} onClick={handleClick}>
            <CutleryIco className="me-2"/>
            {name}
        </button>
    )
}

export default MenuTab;